import { Purchase } from 'models/Purchase'
import { PaymentSource, Transaction } from 'models/Transaction'
import { RootState, TypedDispatch } from 'redux/store'

import { fetchDesignation } from 'redux/services/designation'

export const getPurchaseFromTransaction = async (
  transaction: Transaction,
  store: RootState,
  dispatch: TypedDispatch<RootState>,
): Promise<Purchase> => {
  const designation = await dispatch(
    fetchDesignation.initiate({ designationId: transaction.designation_id }),
  ).unwrap()

  return {
    id: String(transaction.id),
    designationId: String(designation.id),
    grandTotal: String(transaction.total_gross_amount),
    currency: {
      displayed_currency_code: transaction.raw_currency_code,
      displayed_overhead_amount: transaction.raw_overhead_net_amount ?? 0, // should always be 0
      displayed_donation_amount: transaction.raw_donation_gross_amount,
      displayed_total_gross_amount: transaction.raw_total_gross_amount,

      normalized_currency_code: transaction.currency_code,
      normalized_overhead_amount: transaction.overhead_net_amount ?? 0, // should always be 0
      normalized_donation_amount: transaction.donation_gross_amount,
      normalized_total_gross_amount: transaction.total_gross_amount,
      normalized_total_net_amount: transaction.donation_net_amount,

      /**
       * Because these values get set by classypay asynchronously,
       * these will all be null.
       * */
      charged_currency_code: transaction.charged_currency_code ?? undefined,
      charged_total_gross_amount: transaction.charged_total_gross_amount ?? undefined,
      charged_total_net_amount: undefined, // actually doesn't currently exist on transactions
      charged_fees_amount: transaction.charged_classy_fees_amount ?? undefined,
    },
    items: [
      {
        id: String(transaction.id),
        designationId: String(designation.id),
        designationName: designation.name,
        designationExternalReferenceId: designation.external_reference_id,
        name: 'Donation',
        unitPrice: String(transaction.raw_total_gross_amount),
        category: 'Direct Donation',
        quantity: 1,
        frequency: transaction.frequency,
      },
    ],
    zipCode: transaction.billing_postal_code,
    country: transaction.billing_country,
    isCart: false,
    dcf: transaction.is_donor_covered_fee,
    paymentSource: transaction.payment_source as PaymentSource,
    hasDedication: store.order.dedication.hasDedication,
    companyName: transaction.company_name ?? undefined,
    isAnonymous: transaction.is_anonymous,
    companyMatch: {
      id: store.order.doubleTheDonation.value?.companyId ?? undefined,
      name: store.order.doubleTheDonation.value?.companyName || undefined,
    },
    comment: transaction.comment,
  }
}
